export const styles = {
  select: {
    '& .MuiChip-root': {
      maxHeight: '26px',
      backgroundColor: 'primary.main',
      color: 'common.white',
      '& .MuiSvgIcon-root path': {
        fill: 'white',
        opacity: 0.7,
      },
    },
    '& .MuiOutlinedInput-root': { maxHeight: '40px', pr: '10px !important' },
    '& .MuiChip-root:nth-child(-n+51)': {
      transform: 'translateY(40px)',
      zIndex: '1',
    },
  },
  input: {
    maxHeight: '40px',
  },
};
